import HtmlFormGenLgUI from './HtmlFormGenLgUI';

const HtmlFormGenLg = () => {
  return <HtmlFormGenLgUI />;
};

export default HtmlFormGenLg;
